import {SUBMIT_CARD_ORDER, RESET_SUCCESS, RESET_CARD_ORDER, CARD_ORDER_VERIFICATION} from "../action/cardOrder"

const initialState = {
  resultCode: '',
  resultText: '',
  errorMsg: '',
  complete: false,
  cardOrders: []
}

export default (state = initialState, action) => {

  const { type, payload} = action

  switch (type) {
  case SUBMIT_CARD_ORDER + '_FULFILLED':
    return {
      ...state,
      resultCode: payload.resultCode,
      complete: payload.resultCode === 0 || payload.resultCode === "0",
      resultText: payload.resultText
    }
  case RESET_SUCCESS:
  case RESET_CARD_ORDER:
    return {
      ...initialState,
      cardOrders: []
    }
  case CARD_ORDER_VERIFICATION + '_FULFILLED':
    if (payload.resultCode === 0 || payload.resultCode === "0") {
      return {
        ...state,
        resultCode: payload.resultCode,
        cardOrders: payload.resultText
      }
    } else {
      return {
        ...state,
        errorMsg: payload.resultText
      }
    }
  default:
    return state
  }
}
